import React, { PropTypes } from 'react';

import { ArrowLeftLarger, ArrowRightLarger } from '../../../Iconography';

import { arrow, arrowBtnNext, arrowBtnPrev } from './styles.module.css';

export const NextArrow = ({ onClick, className }) => (
  <button className={[arrowBtnNext, className].join(' ')} onClick={onClick}>
    <ArrowRightLarger className={arrow} />
  </button>
);

NextArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

NextArrow.defaultProps = {
  className: '',
  onClick: () => {},
};

export const PrevArrow = ({ onClick, className }) => (
  <button className={[arrowBtnPrev, className].join(' ')} onClick={onClick}>
    <ArrowLeftLarger className={arrow} />
  </button>
);

PrevArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};


PrevArrow.defaultProps = {
  className: '',
  onClick: () => {},
};



// WEBPACK FOOTER //
// ./app/src/components/Carousel/components/Arrow/index.jsx